/**
 * Shared number formatting utilities.
 * ALL monetary values: max 2 decimal places.
 * Factor rates only: max 5 decimal places.
 */

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const currencyFormatterNoCents = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatCurrency = (value) => {
  let num = Number(value) || 0;
  // Eliminate -0 and values that round to -$0.00
  if (Object.is(num, -0) || (num < 0 && num > -0.005)) num = 0;
  return currencyFormatter.format(num);
};

export const formatCurrencyNoCents = (value) => {
  let num = Number(value) || 0;
  if (Object.is(num, -0) || (num < 0 && num > -0.5)) num = 0;
  return currencyFormatterNoCents.format(num);
};

export const formatCurrencyWithCents = formatCurrency;

export const formatNumber = (value, maxDecimals = 2) => {
  const num = Number(value) || 0;
  return num.toLocaleString('en-US', { maximumFractionDigits: maxDecimals });
};

export const formatPercent = (value, maxDecimals = 2) => {
  const num = Number(value) || 0;
  return `${num.toLocaleString('en-US', { maximumFractionDigits: maxDecimals })}%`;
};

export const formatFactorRate = (value) => {
  const num = Number(value) || 0;
  return num.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 5 });
};

/**
 * Format a date string as MM/DD/YYYY using UTC to avoid timezone shifts.
 * Returns '' for null/undefined/empty values.
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${month}/${day}/${year}`;
};
